import { MessageType, type AttributeRefusal } from "odyssey-shared";
import type { AttributesFrame } from "./allocation.ts";

/**
 * The character window's frames as the page reads them (ADR-138's amendment of 2026-10-31, decision 4): an `attributes`
 * frame or an `attributeRefused`, both already within their schemas.
 */

/**
 * One frame for the character store.
 */
export type AttributesEvent = { readonly kind: "frame"; readonly frame: AttributesFrame } | { readonly kind: "refused"; readonly reason: AttributeRefusal };

/**
 * Reads an attribute frame.
 *
 * @param message A parsed text message.
 * @returns The event, or null for any other message.
 */
export function readAttributes(message: Readonly<Record<string, unknown>> & { readonly type: number }): AttributesEvent | null {
  if (message.type === MessageType.Attributes) {
    return { kind: "frame", frame: { values: message["values"] as readonly number[], effective: message["effective"] as readonly number[], bonus: message["bonus"] as readonly number[], points: message["points"] as number, background: message["background"] as string | null, respec: message["respec"] as "free" | "shrine" } };
  }
  if (message.type === MessageType.AttributeRefused) {
    return { kind: "refused", reason: message["reason"] as AttributeRefusal };
  }
  return null;
}
